import { useTranslation } from "react-i18next";
import { FormLabel } from "react-bootstrap";
import CustomSelect from "../../Forms/Element/CustomSelect";
import { SearchOperation } from "../../../../utils/ApiUtils";

/** Situação que a listagem assume quando ninguém escolheu nada, igual ao padrão da grade. */
export const DEFAULT_STATUS = 'ACTIVE';

/**
 * Filtro de situação de uma listagem, com o rótulo.
 *
 * Existe como componente porque a regra não é só desenhar um select: o valor precisa ser
 * enviado sempre, inclusive quando é Ativo, e isso é fácil de esquecer ao copiar o bloco de
 * uma tela para outra. Aqui a tela guarda só o texto do estado escolhido e o filtro sai pronto
 * de `buildStatusFilter`.
 *
 * Não existe opção "todos": o servidor só dispensa o recorte de ativos quando recebe um filtro
 * de situação, e sem filtro ele volta a trazer apenas os ativos. Um "todos" que devolvesse a
 * mesma lista de Ativo seria pior que não ter a opção.
 *
 * A tela que usa este filtro precisa passar `hideInactiveToggle` ao ListPage: o atalho
 * "Inativos" do menu Ações manda um recorte de situação por conta própria, e os dois juntos
 * anulariam a busca.
 */
const StatusFilterSelect = (props) => {
    const { t } = useTranslation();
    const { value, onChange, label } = props;

    const options = [
        { value: 'ACTIVE', label: t('active') },
        { value: 'INACTIVE', label: t('inactive') }
    ];

    return (
        <>
            <FormLabel>{label || t('status')}</FormLabel>
            <CustomSelect
                value={options.find(option => option.value === value)}
                onChange={(option) => onChange(option ? option.value : DEFAULT_STATUS)}
                options={options}
            />
        </>
    );
}

/**
 * Filtro pronto para entrar na busca.
 *
 * Vai sempre, inclusive quando a escolha é Ativo: é a presença deste filtro que faz o servidor
 * parar de impor o recorte de ativos por conta própria.
 */
export const buildStatusFilter = (status) => ({
    field: "status",
    value: status || DEFAULT_STATUS,
    operation: SearchOperation.EQUAL
});

export default StatusFilterSelect;
